import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/AlternateEmailOutlined';
import GitHubIcon from '@mui/icons-material/GitHub';
import InstagramIcon from '@mui/icons-material/Instagram';
import './Sidebar.css';

const Sidebar = () => {
    return (
        <>
            <div className="sidebar">
                <LinkedInIcon className='sidebaricon' onClick={() => { window.open('https://www.linkedin.com/in/alok-kumar-rai-3261b21ba/', '_blank') }} />
                <a className='sidebaricon' href="mailto: alokkumarrai2003@gmail.com"><EmailIcon className='sidebariconemail' /></a>
                <GitHubIcon className='sidebaricon' onClick={() => { window.open('https://github.com/Alok530', '_blank') }} />
                <InstagramIcon className='sidebaricon' onClick={() => { window.open('https://www.instagram.com/rajalok530/', '_blank') }} />
            </div>
        </>
    )
}

export default Sidebar;